import FinancialContent from "../../../../src/pages/use-cases/page-content/financial/data-analysis-financial.md";
import * as React from 'react';
export default {
  FinancialContent,
  React
};